export class Lot {
    id: number;
    name: string;
    status: string;
    cities: string;
    users: string;
    identity_verification: boolean;
    current_address_verification: boolean;
    permanent_address_verification: boolean;
    icr_verification: boolean;
    education_verification: boolean;
    employment_verification: boolean;
    pcc_verification: boolean;
    document_verification: boolean;
    reference_verification: boolean;
    globaldb_verification: boolean;
    created_at: string;
    employee_count: number;
    verifications: any[];
    unique_verifications: any[];
    clients: any[];
    company_id: number;
    company_name: string;
    form_support: number;
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/models/lot.model.ts